import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { setearMiles } from 'util/funciones'
import { DATA_MOCK } from '../utils/contanst'
import './AcordionDetail.css'
const AcordionDetail = ({ datos = DATA_MOCK, negocio = 'COMBUSTIBLE' }) => {

    const mostrarPromocionales = negocio === 'COMPRAS'
    
    // Definir los subtítulos según el negocio
    const getSubtitulos = () => {
        switch(negocio) {
            case 'COMPRAS':
                return [
                    { titulo: 'Combustible', valor: datos.contado?.total || 0 },
                    { titulo: 'Kiosco', valor: datos.marcas_privadas?.total || 0 },
                    { titulo: 'Canastilla', valor: datos.otros_medios_pagos?.total || 0 },
                    { titulo: 'GNV', valor: datos.consumo_interno?.total || 0 },
                    { titulo: 'GLP', valor: datos.credito?.total || 0 },
                    { titulo: 'Promocionales', valor: 0 }
                ]
            case 'INVENTARIOS':
                return [
                    { titulo: 'Combustible', valor: datos.contado?.total || 0 },
                    { titulo: 'Kiosco', valor: datos.marcas_privadas?.total || 0 },
                    { titulo: 'Canastilla', valor: datos.otros_medios_pagos?.total || 0 },
                    { titulo: 'GNV', valor: datos.consumo_interno?.total || 0 },
                    { titulo: 'GLP', valor: datos.credito?.total || 0 }
                ]
            case 'COMBUSTIBLE':
            case 'KIOSCO':
            case 'CANASTILLA':
            case 'GNV':
            case 'GPL':
                return [
                    { titulo: 'Contado', valor: datos.contado?.total || 0 },
                    { titulo: 'Marcas privadas', valor: datos.marcas_privadas?.total || 0 },
                    { titulo: 'Otros medios de pago', valor: datos.otros_medios_pagos?.total || 0 },
                    { titulo: 'Consumos internos', valor: datos.consumo_interno?.total || 0 },
                    { titulo: 'Crédito', valor: datos.credito?.total || 0 },
                    { titulo: 'Recaudos', valor: datos.recaudo?.total || 0 }
                ]
            case 'DIFERENCIAS DE LECTURA':
                return [
                    { titulo: 'Volumen vendido', valor: datos.contado?.total || 0 },
                    { titulo: 'Calibraciones', valor: datos.marcas_privadas?.total || 0 },
                    { titulo: 'Diferencias en mangueras', valor: datos.otros_medios_pagos?.total || 0 },
                    { titulo: 'Diferencias en lectura', valor: datos.consumo_interno?.total || 0 }
                ]
            case 'NOTAS CREDITO':
                return [
                    { titulo: 'Contado', valor: datos?.contado?.total || 0 },
                    { titulo: 'Marcas privadas', valor: datos?.marcas_privadas?.total || 0 },
                    { titulo: 'Otros medios de pago', valor: datos?.otros_medios_pagos?.total || 0 },
                    { titulo: 'Consumos internos', valor: datos?.consumo_interno?.total || 0 },
                    { titulo: 'Crédito', valor: datos?.credito?.total || 0 },
                    { titulo: 'Recaudos', valor: datos?.recaudo?.total || 0 }
                ]
            default:
                return [
                    { titulo: 'Contado', valor: datos.contado?.total || 0 },
                    { titulo: 'Marcas privadas', valor: datos.marcas_privadas?.total || 0 },
                    { titulo: 'Otros medios de pago', valor: datos.otros_medios_pagos?.total || 0 }
                ]
        }
    }

    const subtitulos = getSubtitulos()
    const columnasPorFila = subtitulos.length
    // Calcular el tamaño del grid basado en el número de columnas
    const getGridSize = (): 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 => {
        if (columnasPorFila === 6) return 1
        if (columnasPorFila === 5) return 2
        if (columnasPorFila === 4) return 2
        if (columnasPorFila === 3) return 3
        return 2
    }
    
    return (
        <Accordion>
            <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ display: 'flex', alignItems: 'center', alignSelf: 'center', textAlign: 'center' }}
                expandIcon={<ExpandMore />}
            >
                <Grid container spacing={1} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h1 className='title' style={{ color: '#DE1B08' }} >{negocio}</h1>
                    </Grid>
                    {subtitulos.map((item, index) => (
                        <Grid key={index} item xs={6} md={getGridSize()}>
                            <h2 className='title text-center'>{item.titulo}</h2>
                            <h2 className='mount text-center'>{'$' + setearMiles(item.valor)}</h2>
                        </Grid>
                    ))}
                </Grid>
            </AccordionSummary>
            <AccordionDetails id='table' >
                {negocio === 'NOTAS CREDITO' ? (
                    <table className="table-notas-credito" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Contado</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Marcas privadas</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Otros medios de pago</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Consumos propios</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Crédito</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Recaudos</th>
                            </tr>
                        </thead>
                        <tbody style={{ textAlign: 'center' }}>
                            <tr>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    {(() => {
                                        const detalle = (datos?.contado?.detalle as any) || {};
                                        const items = [];
                                        if (detalle.combustible !== 0 && detalle.combustible !== undefined) {
                                            items.push(<><b>Combustible:</b> ${setearMiles(detalle.combustible)}<br/></>);
                                        }
                                        if (detalle.kiosco !== 0 && detalle.kiosco !== undefined) {
                                            items.push(<><b>Kiosco:</b> ${setearMiles(detalle.kiosco)}<br/></>);
                                        }
                                        if (detalle.canastilla !== 0 && detalle.canastilla !== undefined) {
                                            items.push(<><b>Canastillas:</b> ${setearMiles(detalle.canastilla)}<br/></>);
                                        }
                                        if (detalle.cdl !== 0 && detalle.cdl !== undefined) {
                                            items.push(<><b>CDL:</b> ${setearMiles(detalle.cdl)}<br/></>);
                                        }
                                        if (detalle.glp !== 0 && detalle.glp !== undefined) {
                                            items.push(<><b>GLP:</b> ${setearMiles(detalle.glp)}</>);
                                        }
                                        return items.length > 0 ? (
                                            <div style={{ textAlign: 'left' }}>{items}</div>
                                        ) : '$0';
                                    })()}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    {datos?.marcas_privadas?.total ? `$${setearMiles(datos.marcas_privadas.total)}` : '$0'}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    {(() => {
                                        const detalle = (datos?.otros_medios_pagos?.detalle as any) || {};
                                        const items = [];
                                        if (detalle.combustible !== 0 && detalle.combustible !== undefined) {
                                            items.push(<><b>Combustible:</b> ${setearMiles(detalle.combustible)}<br/></>);
                                        }
                                        if (detalle.kiosco !== 0 && detalle.kiosco !== undefined) {
                                            items.push(<><b>Kiosco:</b> ${setearMiles(detalle.kiosco)}<br/></>);
                                        }
                                        if (detalle.canastilla !== 0 && detalle.canastilla !== undefined) {
                                            items.push(<><b>Canastillas:</b> ${setearMiles(detalle.canastilla)}<br/></>);
                                        }
                                        if (detalle.cdl !== 0 && detalle.cdl !== undefined) {
                                            items.push(<><b>CDL:</b> ${setearMiles(detalle.cdl)}<br/></>);
                                        }
                                        if (detalle.glp !== 0 && detalle.glp !== undefined) {
                                            items.push(<><b>GLP:</b> ${setearMiles(detalle.glp)}</>);
                                        }
                                        return items.length > 0 ? (
                                            <div style={{ textAlign: 'left' }}>{items}</div>
                                        ) : '$0';
                                    })()}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    {datos?.consumo_interno?.total ? `$${setearMiles(datos.consumo_interno.total)}` : '$0'}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    {(() => {
                                        const detalle = (datos?.credito?.detalle as any) || {};
                                        const items = [];
                                        if (detalle.combustible !== 0 && detalle.combustible !== undefined) {
                                            items.push(<><b>Combustible:</b> ${setearMiles(detalle.combustible)}<br/></>);
                                        }
                                        if (detalle.kiosco !== 0 && detalle.kiosco !== undefined) {
                                            items.push(<><b>Kiosco:</b> ${setearMiles(detalle.kiosco)}<br/></>);
                                        }
                                        if (detalle.canastilla !== 0 && detalle.canastilla !== undefined) {
                                            items.push(<><b>Canastillas:</b> ${setearMiles(detalle.canastilla)}<br/></>);
                                        }
                                        if (detalle.cdl !== 0 && detalle.cdl !== undefined) {
                                            items.push(<><b>CDL:</b> ${setearMiles(detalle.cdl)}<br/></>);
                                        }
                                        if (detalle.glp !== 0 && detalle.glp !== undefined) {
                                            items.push(<><b>GLP:</b> ${setearMiles(detalle.glp)}</>);
                                        }
                                        return items.length > 0 ? (
                                            <div style={{ textAlign: 'left' }}>{items}</div>
                                        ) : '$0';
                                    })()}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    {datos?.recaudo?.total ? `$${setearMiles(datos.recaudo.total)}` : '$0'}
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    ${setearMiles(datos?.contado?.total || 0)}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    ${setearMiles(datos?.marcas_privadas?.total || 0)}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    ${setearMiles(datos?.otros_medios_pagos?.total || 0)}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    ${setearMiles(datos?.consumo_interno?.total || 0)}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    ${setearMiles(datos?.credito?.total || 0)}
                                </td>
                                <td style={{ padding: '10px', border: 'none' }}>
                                    ${setearMiles(datos?.recaudo?.total || 0)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                ) : (
                    <table className="table-notas-credito" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Contado</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Marcas privadas</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Otros medios de pago</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Consumos propios</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Crédito</th>
                                <th style={{ textAlign: 'center', padding: '8px', border: 'none', fontWeight: 'normal', fontSize: '14px' }}>Recaudos</th>
                            </tr>
                        </thead>
                        <tbody style={{ textAlign: 'center' }}>
                            <tr>
                                <td style={{ padding: '10px', border: 'none' }} rowSpan={2}><p>{datos.contado.detalle.map(detalle => <><b className='text-capitalize' style={{ textAlign: 'left' }}>{detalle.medio_pago}: </b>{'$' + setearMiles(detalle.total)}<br></br></>)}</p></td>
                                <td style={{ padding: '10px', border: 'none' }} rowSpan={2}><p>{datos.marcas_privadas.detalle.map(detalle => <><b className='text-capitalize' style={{ textAlign: 'left' }}>{detalle.medio_pago}: </b>{'$' + setearMiles(detalle.total)}<br></br></>)}</p></td>
                                <td style={{ padding: '10px', border: 'none' }} rowSpan={2}><p>{datos.otros_medios_pagos.detalle.map(detalle => <><b className='text-capitalize' style={{ textAlign: 'left' }}>{detalle.medio_pago}: </b>{'$' + setearMiles(detalle.total)}<br></br></>)}</p></td>
                                <td style={{ padding: '10px', border: 'none' }} rowSpan={2}><p>{<><b className='text-capitalize' style={{ textAlign: 'left' }}>{'$' + setearMiles(datos.consumo_interno.total)}</b><br></br></>}</p></td>
                                <td style={{ padding: '10px', border: 'none' }} rowSpan={2}><p>{datos.credito.detalle.map(detalle => <><b className='text-capitalize' style={{ textAlign: 'left' }}>{detalle.medio_pago}: </b>{'$' + setearMiles(detalle.total)}<br></br></>)}</p></td>
                                <td style={{ padding: '10px', border: 'none' }} rowSpan={2}><p>{<><b className='text-capitalize' style={{ textAlign: 'left' }}>{'$' + setearMiles(datos.recaudo.total)}</b><br></br></>}</p></td>
                            </tr>
                            <tr>
                            </tr>
                            <tr style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                                <td style={{ padding: '10px', border: 'none' }}><b>${setearMiles(datos.contado.total)}</b></td>
                                <td style={{ padding: '10px', border: 'none' }}><b>${setearMiles(datos.marcas_privadas.total)}</b></td>
                                <td style={{ padding: '10px', border: 'none' }}><b>${setearMiles(datos.otros_medios_pagos.total)}</b></td>
                                <td style={{ padding: '10px', border: 'none' }}><b>${setearMiles(datos.consumo_interno.total)}</b></td>
                                <td style={{ padding: '10px', border: 'none' }}><b>${setearMiles(datos.credito.total)}</b></td>
                                <td style={{ padding: '10px', border: 'none' }}><b>${setearMiles(datos.recaudo.total)}</b></td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </AccordionDetails>
        </Accordion>
    )
}

export default AcordionDetail